/**
 * Landing page render mode switch.
 *
 * - `false` (default): renders the custom React landing page (CustomLandingPage)
 *   composed of section components in src/containers/LandingPage/sections/.
 *   This is the production path.
 *
 * - `true`: renders the hosted PageBuilder landing page driven by the
 *   `content/pages/landing-page.json` page asset managed in Sharetribe Console.
 *   Used as a fallback / emergency switch when the hosted variant is preferred.
 *
 * Flipping this constant is sufficient — `LandingPage.duck.js` reads it to
 * decide whether to fetch the page asset on `loadData`.
 */
export const USE_HOSTED_LANDING_PAGE = false;
